import { ColorScheme } from '@vis.gl/react-google-maps'
import { useTheme } from './useTheme'

// The Google map in the site's theme: Google's own dark map in the dark theme
export const useMapColorScheme = () =>
  useTheme().theme === 'dark' ? ColorScheme.DARK : ColorScheme.LIGHT
